import BuilderVM from './builder-vm';
import WizardPage from 'libs/wizard-page';
import WizardStepNav from 'libs/wizard-step-nav';
let stepProgress;
let currentPageIdx = 0;
const Wiz = {};

Wiz.GeneralInfoPage = function() { this.init.apply(this, arguments); };
Wiz.GeneralInfoPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'js-pb-general-info',
  name: Kadenze.I18n.t('wizard.general_info'),
  icon: 'kf-info',

  validate: function(viewModel) {
    return viewModel.validate(false);
  }
});

Wiz.ProjectMediaPage = function() { this.init.apply(this, arguments); };
Wiz.ProjectMediaPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'js-pb-project-media',
  name: 'Add Media',
  icon: 'kf-star',

  validate: function(viewModel) {
    return viewModel.validate(false);
  }
});

Wiz.FinalizePage = function() { this.init.apply(this, arguments); };
Wiz.FinalizePage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'js-pb-finalize',
  name: 'Finalize',
  icon: 'kf-star',

  validate: function(viewModel) {
    return viewModel.validate(false);
  }
});

const PAGES = [
  new Wiz.ProjectMediaPage(),
  new Wiz.GeneralInfoPage(),
  new Wiz.FinalizePage()
];

  /*--------------------------------------------PAGE NAV FUNCTIONS----------------------------------------------------*/
const initWizard = function () {
  const data = $('#project_json').val();
  const $el = $('#js-project-builder');
  const validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
  self.viewModel = new BuilderVM(data, $el);

  ko.applyBindingsWithValidation(self.viewModel, $el[0], validationOptions);

  const stepObj = {
    numVisible: 1,
    pages: PAGES,
    breakpoints: {
      xs: 1,
      sm: 2,
      lg: 3
    }
  };

    //Init progress bar AFTER ko binds with the DOM so it can get the accurate step count
  stepProgress = new WizardStepNav($('#js-wizardNav'), self, stepObj);

  Kadenze.UIUtil.initExpandableTextareas(); // init expandable fields

  showPageByIndex(0); // start the type select page;

  Kadenze.Share.init();
};

const showPageByIndex = function(index) {
  showPage(PAGES[index]);
  if (self.viewModel) {
    self.viewModel.currentPage(index+1);
  }
};

const showPage = function(pageObj) {
  const $page = $('#' + pageObj.id);
  currentPageIdx = PAGES.indexOf(pageObj);
  $('.js-wiz-step').stop(true, true).hide(); // hide all subpages
  $page.stop(true, true).fadeIn(); // show subpage by pageID
  stepProgress.setActiveStepByIndex(currentPageIdx);
};
  /*----------------------------------------------INIT FUNCTIONS----------------------------------------------------*/
const self =  {
  init: function() {
    console.log('Initializing PortfolioProjectWizard');
    initWizard();
  },
  showPageByIndex: function(index) {
    showPageByIndex(index);
  },
  getProgressInstance: function() {
    return stepProgress;
  }
};

export default self;

